import { environment as uat } from './environment.uat';
import { environment as compiledEnv } from './environment';
import { environment as prod } from './environment.prod';
import { environment as qa } from './environment.qa';
import { environment as dev } from './environment.dev';

export const mapping = {
    'localhost:4200': compiledEnv,

    'portalpas-dev.sancristobalonline.com.ar': dev,
    'portalpas-qa.sancristobalonline.com.ar': qa,

    'productores-dev.sancristobalonline.com.ar': dev,
    'productores-staging.sancristobalonline.com.ar': qa,
    'productores-uat.sancristobalonline.com.ar': uat,

    'portalpas-auto-dev.sancristobalonline.com.ar': dev,
    'portalpas-auto-qa.sancristobalonline.com.ar': qa,

    'claim-dev.sancristobalonline.com.ar': dev,
    'claim-qa.sancristobalonline.com.ar': qa,

    'thirdparty-dev.sancristobalonline.com.ar': dev,
    'thirdparty-qa.sancristobalonline.com.ar': qa,

    'marketing-dev.sancristobalonline.com.ar': dev,
    'marketing-qa.sancristobalonline.com.ar': qa,

    'sintacc-dev.sancristobalonline.com.ar': dev,
    'sintacc-qa.sancristobalonline.com.ar': qa,

    'crossselling-dev.sancristobalonline.com.ar': dev,
    'crossselling-qa.sancristobalonline.com.ar': qa,

    'productores.sancristobal.com.ar': prod,
};
